<template>
  <aside
    class="flex items-center gap-2 rounded-sm bg-primary-50 px-7 py-2 text-primary-950"
  >
    <app-icon icon="ph:lock-simple" :size="20" />
    <div class="text-sm">
      <p
        class="inline"
        v-html="$t('course.page.privatization.know_more_label')"
      />
      <growth-contact-button
        class="ml-1"
        color="primary"
        origin="course"
        origin_page_action="enrolment_intra_cta"
        :origin_page_id="course.slug"
        size="small"
        variant="link"
      >
        {{ $t("app.cta.know_more") }}
      </growth-contact-button>
    </div>
  </aside>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";

defineProps<{
  course: CoursePageView;
}>();
</script>
